export default __webpack_public_path__ + "static/media/shield3.cc1fd1d3.svg";